import React from "react";

const Test = () => {
  return (
    <div className="w-screen h-screen flex flex-col justify-center items-center p-10">
      <div className="w-[400px] h-[400px]">
        <div className="flex w-full h-full border-l-4 border-blue-500">
          <div className="h-full  w-[50px] relative">
            <span className="p-4 absolute -translate-x-1/2  top-[-10px] bg-white">
              <span className="rounded-full bg-green-500 p-2 ">tm</span>
            </span>
          </div>

          <div className="h-full flex flex-col w-[300px]">
            <div className="min-h-0 grow  bg-green-500">2</div>
            <div className="h-[80px] "></div>
          </div>
        </div>
      </div>
      <div className="w-[400px] h-[400px]">
        <div className="flex w-full h-full border-l-4 border-blue-500">
          <div className="h-full  w-[50px] relative">
            <span className="p-4 absolute -translate-x-1/2  top-[-10px] bg-white">
              <span className="rounded-full bg-green-500 p-2 ">tm</span>
            </span>
          </div>

          <div className="h-full flex flex-col w-[300px]">
            <div className="min-h-0 grow  bg-green-500">2</div>
            <div className="h-[80px] "></div>
          </div>
        </div>
      </div>
      <div className="w-[400px] h-[400px]">
        <div className="flex w-full h-full border-l-4 border-blue-500">
          <div className="h-full  w-[50px] relative">
            <span className="p-4 absolute -translate-x-1/2  top-[-10px] bg-white">
              <span className="rounded-full bg-green-500 p-2 ">tm</span>
            </span>
          </div>

          <div className="h-full flex flex-col w-[300px]">
            <div className="min-h-0 grow  bg-green-500">2</div>
            <div className="h-[80px] "></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Test;
